/**
 * iOS keyboards often insert curly/smart apostrophes. Email local-parts require ASCII `'`.
 */
export const normalizeEmailInput = (value: string): string =>
  value.replace(/[\u2018\u2019\u201A\u201B\u2032\u2035]/g, "'");

export const emailValidation = (value: string) => {
  const emailValidationRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; // eslint-disable-line

  return emailValidationRegex.test(normalizeEmailInput(value));
};

/** useInput getter for email fields - normalises curly quotes as the user types. */
export const getEmailInputValue = (event: { target?: { value?: string } }): string =>
  normalizeEmailInput(event?.target?.value ?? '');

export const isEmptyValidation = (value: string) => value.trim() !== '';

export const isNullValidation = (value: any) => value !== null;

export const noValidation = (value: any) => true;
